import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRISM_BOOKING_URL, PRISM_PHONE, PRISM_PHONE_HREF } from "./prismData";

/**
 * Section F2 — Closing CTA.
 * Placed directly above the existing "Start with a conversation" section
 * (which is kept).
 */
export default function ClosingCtaSection() {
  return (
    <section
      className="relative bg-light-blue/40 py-16 lg:py-24"
      aria-labelledby="prism-closing-cta-heading"
    >
      <div className="container-px mx-auto max-w-3xl text-center">
        <h2
          id="prism-closing-cta-heading"
          className="font-headings text-2xl font-bold text-primary sm:text-3xl lg:text-[2.5rem]"
        >
          Healing is possible, and you don&rsquo;t have to figure it out alone.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
          If anything on this page sounded like you, that&rsquo;s reason enough
          to reach out. We&rsquo;ll listen, review what you&rsquo;ve tried, and
          tell you honestly whether Prism fits.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Button
            asChild
            size="lg"
            className="bg-gradient-accent text-accent-foreground shadow-glow hover:opacity-90"
          >
            <a href={PRISM_BOOKING_URL}>
              Book a consultation
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="border-2 border-primary/30 bg-transparent text-primary hover:bg-primary/5"
          >
            <a href={PRISM_PHONE_HREF}>
              <Phone className="mr-2 h-4 w-4" />
              Call {PRISM_PHONE}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
